import React from 'react';
import tw from 'twin.macro';

const SubmitButton = tw.button`flex flex-row items-center my-2 bg-plutoblue-500 dark:bg-darkButton  hover:bg-plutoblue-400 dark:hover:bg-darkButtonHover text-white text-sm px-4 py-2 md:px-8 md:py-3 rounded-full transition-all`;

export default SubmitButton;
